
import makeErrorMessage from './makeErrorMessage'

export default (promise, opts = {}) =>
  promise.catch(error => {
    const errorString = error.toString()
    error.toString = () => {
      try {
        return makeErrorMessage(error, opts)
      } catch (err) {
        return errorString
      }
    }
    throw error
  })
